<template>
    <q-layout view="hhh Lpr LFf">
        <div v-if="isAuthInitialized == false">
            <transition name="slide" mode="out-in">
                <router-view language="en"></router-view>
            </transition>
        </div>
        <div v-else>
            <initial-loader />
        </div>
    </q-layout>
</template>

<script>
import 'select2';
import 'select2/dist/css/select2.min.css';
import axios from 'axios';
import jwt_decode from 'jwt-decode';

export default {
    name: 'App',
    beforeCreate() {
        axios.get('/setting.json').then((res) => {
            if (res.data.baseUrl) {
                this.$store.commit('setBaseUrl', res.data.baseUrl);
            } else if (res.data.BASE_URL) {
                this.$store.commit('setBaseUrl', res.data.BASE_URL);
            }
        });
    },
    mounted() {
        const token = sessionStorage.getItem('token')
        if (!token) {
            return;
        }
        this.$store.commit('setAuthInitialized', true);
        if (token && typeof token === 'string') {
            axios.defaults.headers['Authorization'] = `Bearer ${token}`;
          const decodedToken = jwt_decode(token);

            let expiryDuration = decodedToken.exp - new Date().getTime() / 10000000;
            // let expiryDuration = 2;
            // console.log('expiryDuration: ', expiryDuration);
            if (expiryDuration < 1) {
                this.$store.commit('logOutHandler');
            } else {
                let userData = {
                    userId: decodedToken.unique_name,
                    userName: decodedToken.given_name,
                    roleId: decodedToken.role,
                    isloggedIn: true,
                    isAuthenticated: true,
                };             
                setTimeout(() => {
                    this.$store.commit('loginHandler', userData)
                    this.$store.dispatch('getUserMenus');
                }, 100);
            }
        } else {
            this.$store.commit('logOutHandler');
        }
    },
    computed: {
        isAuthInitialized() {
            return this.$store.state.authInitialized;
        },
    },
};
</script>

<style lang="scss">
@import './styles/quasar.scss';
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
body {
    background-color: #ebf4f5 !important;
}

.imageClass .complements .flux-controls .pause,
.play,
.toggle {
    display: none !important;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter {
    opacity: 0;
    transform: translateX(30px);
}

.slide-leave-to {
    opacity: 0;
    transform: translateX(-30px);
}
</style>
